import { iconsList as icons } from "app/regions/blocks/icons/icons-list"

export const getIconFromUrl = userInput => {
  const httpUrl = checkHttp(userInput)
  const url = new URL(httpUrl)
  const hostname = url.hostname
  const name = findHostname(hostname)
  const iconNames = icons.map(icon => icon.name)
  const result = iconNames.includes(name) ? name : "external-link"
  return { icon: result, url: httpUrl }
}


function checkHttp(url) {
  return url.startsWith("http") ? url : `https://${url}`
}

function findHostname(hostname) {
  const split = hostname.split(".")
  const target = split.length - 2
  return split[target]
}
